import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { map, of } from 'rxjs';
import { PurchaseRequestResponseDto } from '../interfaces/purchase-response.dto';
import { AbstractPurchasingService } from '../services/abstract-purchasing.service';

export const purchaseDetailResolver: ResolveFn<PurchaseRequestResponseDto | null> = (
  route: ActivatedRouteSnapshot
) => {
  const purchasingService = inject(AbstractPurchasingService);
  const purchaseId = route.paramMap.get('purchaseId');

  if (!purchaseId) return of(null);

  const cachedPurchase = purchasingService.getCache(purchaseId);
  
  if (cachedPurchase) {
    return of(cachedPurchase);
  }

  return purchasingService.findPurchaseById(purchaseId).pipe(
    map(res => res.body)
  );
};